import React, { useEffect } from 'react';
import { Footer } from './components/Footer';
import { MobileTopButton } from './components/MobileTopButton';
import { SiteHeader } from './components/SiteHeader';
import { StickyCTA } from './components/StickyCTA';
import { replaceRoute, useCurrentRoute } from './lib/router';
import { AboutPage } from './pages/AboutPage';
import { AdminPage } from './pages/admin/AdminPage';
import { HomePage } from './pages/HomePage';
import { MembershipPage } from './pages/MembershipPage';
import { RetreatSpacePage } from './pages/RetreatSpacePage';
import { StaysPage } from './pages/StaysPage';
const PAGE_TITLES: Record<string, string> = {
  '/': 'Pines Retreat | Stay, Sauna, Cold Water & Retreat Space in Kfar Pines',
  '/space': 'Retreat Space | Pines Retreat',
  '/stay': 'Stay Overnight Near Pardes Hanna | Pines Retreat',
  '/membership': 'Pines Membership | Pines Retreat',
  '/about': 'About Zev | Pines Retreat',
  '/admin': 'Events editor | Pines Retreat'
};
export function App() {
  const route = useCurrentRoute();
  useEffect(() => {
    document.title = PAGE_TITLES[route] ?? PAGE_TITLES['/'];
  }, [route]);

  // If a sign-in link lands anywhere other than /admin, send it there.
  useEffect(() => {
    const {
      hash
    } = window.location;
    if (route !== '/admin' && /access_token=|error_description=/.test(hash)) {
      replaceRoute(`/admin${hash}`);
    }
  }, [route]);
  if (route === '/admin') return <AdminPage data-id="element-0" data-mp="2zm4xqkjlzd1t" />;
  const page = {
    '/': <HomePage data-id="element-1" data-mp="2zn66ujh2dpgw" />,
    '/space': <RetreatSpacePage data-id="element-2" data-mp="33mf0loc3tncg" />,
    '/stay': <StaysPage data-id="element-3" data-mp="33ngf62sbwryx" />,
    '/membership': <MembershipPage data-id="element-4" data-mp="33orjc3pos1qk" />,
    '/about': <AboutPage data-id="element-5" data-mp="38m1iwc6shts4" />
  }[route] ?? <HomePage data-id="element-6" data-mp="38kqfwel64q22" />;
  return <div className="min-h-screen bg-cream font-sans text-pine selection:bg-ember selection:text-cream" data-id="element-7" data-mp="38kglmet3bwqk">
      <SiteHeader data-id="element-8" data-mp="3dirtwl3qlz6o" />
      <main className="pb-20 md:pb-0" data-id="element-9" data-mp="nvj2rdpwcaoo">{page}</main>
      <Footer data-id="element-10" data-mp="nur8c681cizz" />
      <StickyCTA data-id="element-11" data-mp="nvar1p5ifbf2" />
      <MobileTopButton data-id="element-12" data-mp="nxww9i4xheu4" />
    </div>;
}